<template>
  <div class="home">
    <Banner />
    <Course />
    <News />
  </div>
</template>

<script>

import Banner from '@/components/Home/Banner.vue';
import Course from '@/components/Home/CourseVideo.vue';
import News from '@/components/Home/News.vue';

export default {
  components: {
    Banner,
    Course,
    News,
  },
};
</script>

<style lang="scss" scoped>
</style>
